import { persistReducer, type PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import type { Reducer } from 'redux';

export const createPersistConfig = <T>(key: string, whitelist?: string[]): PersistConfig<T> => ({
  key: `sama_${key}`,
  storage,
  whitelist,
  version: 1,
  migrate: (state: any) => Promise.resolve(state),
});

export const persistSliceReducer = <T>(
  reducer: Reducer<T>,
  persistConfig: ReturnType<typeof createPersistConfig<T>>
) => persistReducer(persistConfig, reducer);
